import { FaqItemResponseType, FaqSaveRequestType, FaqSaveResponseType } from 'src/models/DonationPage/Question';
import {
  CommonDeleteItemRequestType,
  CommonDeleteItemResponseType,
  CommonGetItemRequestType,
  CommonListCopyItemResponseType,
  CommonListReorderResponseType,
  CommonListReorderType,
  CommonListRequestType,
  CommonListResponseType,
} from 'src/models/listTypes';
import { httpPost } from 'src/utils/http';

const path = '/SetupQuestions';

/** get questions list */
export const apiGetQuestionsList = ({
  limit,
  campaignID,
  offset,
}: CommonListRequestType): Promise<CommonListResponseType> =>
  httpPost(`${path}/LoadItems`, {
    BatchSize: limit,
    CampaignID: campaignID,
    LoadFromIndex: offset,
  });

/** get question details */
export const apiGetQuestionsItem = (id: CommonGetItemRequestType): Promise<FaqItemResponseType> =>
  httpPost(`${path}/LoadItemDetails`, {
    ItemID: id,
  });

/** save a question item */
export const apiSaveQuestionItem = (data: FaqSaveRequestType): Promise<FaqSaveResponseType> =>
  httpPost(`${path}/SaveItem`, data);

/** reorder question items */
export const apiReorderFaqList = (data: CommonListReorderType): Promise<CommonListReorderResponseType> =>
  httpPost(`${path}/ReorderItem`, {
    ItemId: data[0],
    NewSequence: data[2] + 1,
  });

/** copy a question item */
export const apiCopyFaqItem = (id: CommonGetItemRequestType): Promise<CommonListCopyItemResponseType> =>
  httpPost(`${path}/CopyItem`, {
    ItemID: id,
  });

/** delete a question */
export const apiDeleteFaq = (id: CommonDeleteItemRequestType): Promise<CommonDeleteItemResponseType> =>
  httpPost(`${path}/DeleteItem`, {
    ItemID: id,
  });
